import React from "react";
import styled from "styled-components";

export default ({ children }) => <Wrap>{children}</Wrap>;

const Wrap = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fbfaf7;
  z-index: 2;
`;



// WEBPACK FOOTER //
// ./src/components/generic/kit/Modal/index.js